export default __webpack_public_path__ + "static/media/h5mgr.aa9d64b5.svg";